import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import React from 'react'
import styles from './CommentThread.module.sass'
import CommentReply from './CommentReply'

const CommentReplies = ({ replies }) => {
	const { i18n } = useGlobal()

	return replies.length > 0 ? (
		replies.map((reply) => <CommentReply key={reply.id} reply={reply} />)
	) : (
		<div className={styles['horizontal-padding']}>
			<small>{i18n`No replies.`}</small>
		</div>
	)
}

export default CommentReplies
